/**
 * 全站路由 TDK 配置 + 安装钩子
 * 关键词按「页面分工」铺：首页吃核心词，列表页吃地域×类型聚合词，
 * 详情页由 buildDetailSeo 用真实房源字段生成长尾词（见 src/utils/seo.js）
 */
import { applySeo, setCurrentRoute } from '@/utils/seo'

const SITE = '铭顺转铺网'
const SITE_URL = 'https://www.mszpw.com.cn'

// 会员中心 / 登录 / 发布 / 搜索结果等页面不需要收录，避免浪费抓取配额和重复内容
const NOINDEX_ROUTES = [
    'Login', 'UserAgreement',
    'ProfileInfo', 'ProfileCertifiedManager', 'ProfileLogin', 'ProfileCollect',
    'PublishRelease', 'PublishRent', 'PublishLease', 'PublishVideoProperty', 'MyVideoProperty',
    'HelpContact', 'HelpLeave', 'HelpMini',
    'Search'
]

const DEFAULT_META = {
    title: '苏州商铺转让_店铺出租_生意转让信息平台 - ' + SITE,
    description: SITE + '提供商铺转让、店铺出租、旺铺转让、求租求购等真实房源信息，覆盖苏州、无锡等城市，找店转店更省心。',
    keywords: '商铺转让,店铺转让,商铺出租,旺铺转让,生意转让,' + SITE
}

const ROUTE_META = {
    Home: DEFAULT_META,

    ShopTransfer: {
        title: '商铺转让_店铺转让_旺铺转让信息 - ' + SITE,
        description: SITE + '商铺转让频道，汇集临街旺铺、餐饮店、便利店等真实转让房源，可按城市、区域、行业、面积筛选。',
        keywords: '商铺转让,店铺转让,旺铺转让,店面转让,餐饮店转让,商铺转让平台'
    },
    Shoprental: {
        title: '商铺出租_店面出租_临街商铺出租信息 - ' + SITE,
        description: SITE + '商铺出租频道，提供临街商铺、商场铺位、社区底商等出租房源，面积、租金、行业信息一目了然。',
        keywords: '商铺出租,店面出租,门面出租,临街商铺出租,商铺招租,商铺租赁'
    },
    ShopforRent: {
        title: '商铺求租_找店求租_店铺求租信息 - ' + SITE,
        description: SITE + '商铺求租频道，发布找店需求、查看求租信息，快速匹配合适铺源。',
        keywords: '商铺求租,找店铺,店铺求租,求租商铺,租店面,找铺面'
    },
    ShopTransferDetail: {
        title: '商铺转让详情 - ' + SITE,
        description: '查看商铺转让房源的详细信息，包括面积、租金、转让费、行业与所在区域。',
        keywords: '商铺转让,店铺转让详情,旺铺转让信息'
    },
    ShoprentalDetail: {
        title: '商铺出租详情 - ' + SITE,
        description: '查看商铺出租房源的详细信息，包括面积、租金、行业与所在区域。',
        keywords: '商铺出租,店面出租详情,临街商铺出租信息'
    },
    ShopforRentDetail: {
        title: '商铺求租详情 - ' + SITE,
        description: '查看商铺求租需求的详细信息，包括意向区域、意向行业与面积。',
        keywords: '商铺求租,找店需求,求租商铺信息'
    },
    CompletedCase: {
        title: '成交案例_商铺转让出租成功案例 - ' + SITE,
        description: SITE + '真实成交案例，展示商铺转让、商铺出租的成交价格与成交周期。',
        keywords: '商铺成交案例,店铺转让成交,商铺出租成交,成交案例'
    },
    CompletedCaseDetail: {
        title: '成交案例详情 - ' + SITE,
        description: '查看商铺成交案例详情，了解成交价、成交周期与铺源信息。',
        keywords: '商铺成交案例,成交案例详情'
    },
    Businesscoper: {
        title: '招商合作_商业项目招商信息 - ' + SITE,
        description: SITE + '招商合作频道，提供商圈、商业体、品牌选址等合作信息。',
        keywords: '招商合作,商业招商,品牌选址,商铺招商'
    },
    BusinesscoperDetail: {
        title: '招商合作详情 - ' + SITE,
        description: '查看招商合作项目详情。',
        keywords: '招商合作,招商项目详情'
    },
    VideoCase: {
        title: '成交视频案例_商铺转让出租实拍 - ' + SITE,
        description: SITE + '成交视频案例，实拍展示商铺转让与出租成交过程。',
        keywords: '成交视频,商铺成交案例,商铺转让视频'
    },
    VideoCaseDetail: {
        title: '成交视频案例详情 - ' + SITE,
        description: '查看成交视频案例详情。',
        keywords: '成交视频案例,商铺成交视频'
    },
    Latestrans: {
        title: '最新成交_商铺转让出租成交动态 - ' + SITE,
        description: SITE + '最新成交动态，实时更新商铺转让与出租成交信息。',
        keywords: '最新成交,商铺成交动态,店铺转让成交'
    },
    InformNotice: {
        title: '通知公告_平台公告 - ' + SITE,
        description: SITE + '通知公告，发布平台规则、服务说明与最新公告。',
        keywords: '通知公告,铭顺转铺网公告,平台公告'
    },
    InformDetail: {
        title: '公告详情 - ' + SITE,
        description: '查看平台公告详情。',
        keywords: '公告详情,平台公告'
    },
    CorporateCulture: {
        title: '企业文化_关于' + SITE,
        description: '了解' + SITE + '的企业文化与服务理念。',
        keywords: '企业文化,铭顺转铺网,关于我们'
    },
    PublishVideoProperty: {
        title: '发布视频房源 - ' + SITE,
        description: '发布视频房源，上传房源实拍视频，让找店客户更直观地了解铺源。',
        keywords: '视频房源,发布视频房源,商铺视频,铭顺转铺网'
    },
    MyVideoProperty: {
        title: '我的视频房源 - ' + SITE,
        description: '管理我发布的视频房源。',
        keywords: '我的视频房源,视频房源管理'
    },
    VideoPropertyList: {
        title: '视频房源_商铺实拍视频_找店转店 - ' + SITE,
        description: SITE + '视频房源频道，提供商铺、店面的实拍视频，可按城市、区域、行业筛选，直观看好铺。',
        keywords: '视频房源,商铺视频,店铺实拍,商铺实拍视频,找店视频,铭顺转铺网'
    },
    VideoPropertyDetail: {
        title: '视频房源详情 - ' + SITE,
        description: '查看视频房源的实拍视频、行业、面积、区域与联系方式。',
        keywords: '视频房源详情,商铺实拍视频,视频看铺'
    }
}

export function installSeo(router) {
    router.afterEach((to) => {
        setCurrentRoute(to.name || '')
        const meta = Object.assign({}, DEFAULT_META, ROUTE_META[to.name] || {})

        // 搜索结果页把用户搜的词带进标题，但保持 noindex
        if (to.name === 'Search' && to.query && to.query.value) {
            meta.title = to.query.value + '_商铺搜索结果 - ' + SITE
            meta.description = '在' + SITE + '搜索「' + to.query.value + '」相关的商铺转让、出租房源。'
        }

        meta.noindex = NOINDEX_ROUTES.indexOf(to.name) !== -1
        // history 模式下每个 URL 都是独立页面，按当前完整路径生成 canonical
        // 详情页带 ?id=xxx，因此每套房源都有各自的规范链接
        // 首页实际路由是 /home，但 index.html 与快照页都指向 /，统一到根路径
        meta.canonical = to.name === 'Home'
            ? SITE_URL + '/'
            : SITE_URL + to.fullPath.replace(/#.*$/, '')
        applySeo(meta)
    })
}

export { DEFAULT_META, ROUTE_META, NOINDEX_ROUTES }
